import { orderTeams, cloneRow } from "./internal/tiebreak.js";
/** Group maximal consecutive runs of unresolved rows into id-groups (≥2). */
function unresolvedRuns(rows) {
    const groups = [];
    let run = [];
    for (const r of rows) {
        if (r.unresolved) {
            run.push(r.teamId);
        }
        else if (run.length > 0) {
            if (run.length >= 2)
                groups.push(run);
            run = [];
        }
    }
    if (run.length >= 2)
        groups.push(run);
    return groups;
}
/**
 * Compute cross-pool division seeding (spec §7.8).
 *
 * Teams are grouped by pool FINISH POSITION (all 1st-place teams, then all
 * 2nd, ...) so every pool winner seeds ahead of every runner-up regardless of
 * record; within each finish group, order by winPct → avg countedRA →
 * avg countedRS → head-to-head (abstains unless every pair met) → unresolved.
 * A single-pool division's seeding is exactly its pool standings order.
 */
export function computeSeeds(standings, games, _config) {
    const countedPool = games.filter((g) => g.type === "pool" && (g.status === "final" || g.status === "forfeit"));
    const toSeeds = (rows) => rows.map((r, i) => ({
        seed: i + 1,
        teamId: r.teamId,
        teamName: r.teamName,
        poolId: r.poolId,
        poolFinish: r.rank,
        unresolved: r.unresolved,
    }));
    // Single pool: seeding IS the pool standings order (§7.8.3).
    if (standings.length === 1) {
        const rows = standings[0].rows;
        return { seeds: toSeeds(rows), unresolvedGroups: unresolvedRuns(rows) };
    }
    const allRows = standings.flatMap((p) => p.rows.map(cloneRow));
    const maxRank = allRows.reduce((m, r) => Math.max(m, r.rank), 0);
    const orderedRows = [];
    const unresolvedGroups = [];
    for (let finish = 1; finish <= maxRank; finish++) {
        const group = allRows.filter((r) => r.rank === finish);
        /* v8 ignore next */
        if (group.length === 0)
            continue;
        const { ordered, unresolvedGroups: ug } = orderTeams(group, countedPool);
        orderedRows.push(...ordered);
        unresolvedGroups.push(...ug);
    }
    return { seeds: toSeeds(orderedRows), unresolvedGroups };
}
//# sourceMappingURL=seeding.js.map